import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { WaitlistForm } from "@/components/soon/WaitlistForm";

export const SoonBadge = ({ className = "" }) => (
  <span className={`soon-badge ${className}`} data-testid="soon-badge"><Sparkles className="h-3 w-3" /> Bientôt disponible</span>
);

export const SoonPage = ({ testid, eyebrow, title, text, visual, features, interest, other }) => (
  <div className="space-y-8" data-testid={testid}>
    <section className="soon-hero grid items-center gap-8 overflow-hidden rounded-3xl p-6 sm:p-10 lg:grid-cols-[1.1fr_1fr]">
      <div className="space-y-4 fade-up">
        <SoonBadge />
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-white/70">{eyebrow}</p>
        <h1 className="text-4xl font-extrabold leading-tight text-white sm:text-5xl">{title}</h1>
        <p className="max-w-lg text-base text-white/80">{text}</p>
      </div>
      <div className="flex justify-center">{visual}</div>
    </section>
    <div className="grid gap-6 lg:grid-cols-[1.4fr_1fr]">
      <ul className="stagger grid gap-4 sm:grid-cols-2" data-testid={`${testid}-features`}>{features.map(([Icon, t, d]) => (
        <li key={t} className="card-surface lift space-y-2 p-5"><span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary/10"><Icon className="h-5 w-5 text-primary" /></span><h3 className="font-extrabold">{t}</h3><p className="text-sm text-muted-foreground">{d}</p></li>))}</ul>
      <div className="space-y-4">
        <WaitlistForm defaultInterest={interest} />
        <Link to={other[0]} className="card-surface lift flex items-center justify-between gap-3 p-4 text-sm font-bold" data-testid={`${testid}-other`}>{other[1]} <ArrowRight className="h-4 w-4" /></Link>
      </div>
    </div>
  </div>
);
